var map = {
	"./francereview01.webp": 5976,
	"./francereview02.webp": 373,
	"./francereview03.webp": 9274,
	"./francereview04.webp": 6039,
	"./francereview06.webp": 1521,
	"./francereview07.webp": 6790,
	"./francereview09.webp": 5984,
	"./francereview10.webp": 2502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8166;